import type { Clinic } from "./clinics.types";

import usClinicsData from "./us-clinics.json";
import frClinicsData from "./fr-clinics.json";
import caClinicsData from "./ca-clinics.json";
import mxClinicsData from "./mx-clinics.json";

export const localClinicsData = [
  ...(usClinicsData as unknown as Clinic[]),
  ...(frClinicsData as unknown as Clinic[]),
  ...(caClinicsData as unknown as Clinic[]),
  ...(mxClinicsData as unknown as Clinic[]),
];

export const localClinicNames = localClinicsData
  .map((clinic) => clinic.name)
  .sort((a, b) => a.localeCompare(b));
